module.exports = "/img/_/_/_/assets/images/creeper/book/common//23.jpg?1de594733dc3ddedab5762e433b0bc40";